import { EEventType } from '../../../../enums/EEventType';
import OY from '../../../../types/OY';
import { IOYProductPropProps, IOYProductPropState } from './const';
import template from './index.art';
import styles from './index.module.less';
import { jeact } from '../../../../decorators/jeact';

@jeact({ autoRender: true })
export default class OYProductProp extends OY<IOYProductPropProps, IOYProductPropState> {
  static displayName = 'OYProductProp';

  static defaultProps: Partial<IOYProductPropProps> = {};

  public state: IOYProductPropState = {
    width: ''
  };

  $node?: { [i: string]: JQuery; } | undefined = {};

  // getDerivedStateFromProps(props: IOYProductPropProps, state: IOYProductPropState) {
  //   const width = `${100 / Object.keys(props.info).length}%`
  //   return { ...state, width }
  // }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  componentDidMount() {
    let childWidth = 0;
    const width = $('.oy-filter').width();

    const cloneEl = this.$el.clone()
      .css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block'
      });

    cloneEl.appendTo('body');
    const childrens = cloneEl.children();
    childrens.each((_i, child) => {
      childWidth += child.getBoundingClientRect().width;
    });

    childWidth = Math.ceil(childWidth)

    const marginWidth = ((width - childWidth - 40) / (childrens.length - 1)).toFixed(2);
    cloneEl.remove();

    this.$el.children().each((index, element) => {
      if (index < childrens.length - 1) {
        $(element).css({ 'margin-right': marginWidth + 'px' })
      }
    })
    // console.log(width - childWidth, marginWidth);
  }

  renderDropdownInput() {
    this.$el.find('oy-dropdown-input').each((_index, element) => {
      const $element = $(element);
      const key = $element.data('key');
      const { info, value } = this.props;
      $element.OYDropdownInput({
        ...info[key],
        value: value[key][0] || '',
        dropdownOffset: 10,
        nameStyle: {
          fontWeight: 500
        },
        onChange: (cvalue: string) => {
          this.eventEmitter.emit(EEventType.onChange, [cvalue], key)
        }
      })
    })
  }

  renderDropdownInputRange() {
    this.$el.find('oy-dropdown-input-range').each((_index, element) => {
      const $element = $(element);
      const key = $element.data('key');
      const { info, value } = this.props;
      $element.OYDropdownInputRange({
        ...info[key],
        value: value[key] || [],
        dropdownOffset: 10,
        valtype: 'positiveFloat',
        nameStyle: {
          fontWeight: 500
        },
        onChange: (cvalue: string[]) => {
          // TODO: 这里需要做反向赋值
          this.eventEmitter.emit(EEventType.onChange, cvalue, key)
        }
      })
    })
  }

  renderSelect() {
    this.$el.find('oy-select').each((index, element) => {
      const $element = $(element);
      const key = $element.data('key');
      const { info, value } = this.props;
      const select = $element.OYSelect({
        value: value[key][0] || '',
        info: info[key].info,
        placeholder: info[key].name,
        placeholderColor: '#333',
        simple: true,
        hoverHighlight: true,
        // align: index === 0 ? 'left' : 'center',
        dropdownOffset: 10,
        hideLabelValue: true,
        nameStyle: {
          fontWeight: 500,
          color: '#333333'
        },
        onChange: (cvalue: string) => {
          this.eventEmitter.emit(EEventType.onChange, [cvalue], key)
        }
      });
    })
  }

  setNode() { }
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/components/OYProductProp/index.ts